module.exports = __webpack_public_path__ + "f976ca1b05a45aea556efdee4b4c2b9c.svg";